import styled from 'styled-components';
import {
  slideDown,
  slideUp,
  positionRelative,
  positionAbsolute,
  fadeDisappear,
  fadeAppear,
} from '../../../../shared/animations';
import { Box } from '@capitalise/ui-design-system';

const show = `
  animation-name: show;

  @keyframes show {
      0% {
        transform: translateY(0);
      }

      100% {
        transform: translateY(76%);
        width:300px;
      }
  }
`;

const hide = `
animation-name: hide;

@keyframes hide {
    0% {
      transform: translateY(76%);
      width:340px;
      z-index: -1;
    }
  
    100% {     
      transform: translateY(0);
    }
}
`;

const defaultAnimation = `
    animation-duration: .5s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
`;

const CollapsableBox = styled(Box)`
  ${(props) => (props.isExpanded === false ? slideUp(props.height) : slideDown(props.height))};
  ${defaultAnimation};
`;

const ToggleBox = styled(Box)`
  ${(props) => (props.hide ? hide : show)}
  ${defaultAnimation}
`;

const TextAnimation = styled(Box)`
  ${(props) => (props.hide ? positionAbsolute : positionRelative)}
  ${defaultAnimation}
`;

const ProgressAnimated = styled(Box)`
  ${(props) => (props.isExpanded ? fadeDisappear : fadeAppear)}
  ${defaultAnimation}
`;

export { CollapsableBox, ToggleBox, TextAnimation, ProgressAnimated };
